import { createReducer, on } from '@ngrx/store';
import * as PromotionActions from './promotions.actions';
import { Promotion } from './promotions.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface PromotionsState {
    promotions: Promotion[];
    promotion: Promotion | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialPromotionsState: PromotionsState = {
    promotions: [],
    promotion: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Promotions Reducer
export const promotionsReducer = createReducer(
    initialPromotionsState,

    // On Load Promotions
    on(PromotionActions.loadPromotions, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PromotionActions.loadPromotionsSuccess, (state, { promotions }) => ({
        ...state,
        isLoading: false,
        promotions: promotions,
    })),
    on(PromotionActions.loadPromotionsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Promotion
    on(PromotionActions.loadPromotion, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PromotionActions.loadPromotionSuccess, (state, { promotion }) => ({
        ...state,
        isLoading: false,
        promotion: promotion,
    })),
    on(PromotionActions.loadPromotionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(PromotionActions.createPromotion, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PromotionActions.createPromotionSuccess, (state, { promotion }) => ({
        ...state,
        isLoading: false,
        promotions: [...state.promotions, promotion],
    })),
    on(PromotionActions.createPromotionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(PromotionActions.updatePromotion, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PromotionActions.updatePromotionSuccess, (state, { promotion }) => ({
        ...state,
        isLoading: false,
        promotions: state.promotions.map((p) =>
            p.id === promotion.id ? promotion : p
        ),
    })),
    on(PromotionActions.updatePromotionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(PromotionActions.deletePromotion, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(PromotionActions.deletePromotionSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        promotions: state.promotions.filter((p) => p.id !== id),
    })),
    on(PromotionActions.deletePromotionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
